module.exports = __webpack_public_path__ + "img/background.f90b480c.jpeg";